import { useEditarConfigDeEnvelopeContext } from "../..";
import OrSpinner from "../../../../../../Components/Utils/OrSpinner";
import { InserirConfigEnvelopeDestinatarioController } from "../../../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeDestinatario/ConfigEnvelopeDestinatarioControllers";
import { TFlagsConfigEnvelopeDestinatario } from "../../../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeDestinatario/ConfigEnvelopeDestinatarioInterfaces";
import DestinatarioASerInseridoNaConfiguracao from "../DestinatarioASerInseridoNaConfiguracao";

interface ITabelaInserirDestinatarioRelacaoProps {}

const objTipoRelacaoClientePorFlag: Record<
    TFlagsConfigEnvelopeDestinatario,
    string
> = {
    FL_PROPONENTE: "Proponente",
    FL_USUARIO_RESPONSAVEL_CASO: "Atendente Solicitação",
    FL_USUARIO_RESPONSAVEL_CONTA: "Corretor Responsável",
    FL_GERENTE: "Gerente de Vendas",
    FL_GERENTE_COMERCIAL: "Gerente Comercial",
    FL_GERENTE_REGIONAL: "Gerente Regional",
    FL_DIRETOR: "Diretor",
    FL_COORDENADOR_VENDAS: "Coordenador de Vendas",
    FL_COORDENADOR_MARKETING: "Coordenador de Marketing",
    FL_SUPERINTENDENTE: "Superintendente",
};

export default function TabelaInserirDestinatarioRelacao(
    props: ITabelaInserirDestinatarioRelacaoProps
) {
    const {
        idConfigEnvelope,
        destinatariosConfigEnvelope: { lst: lstDestinatariosConfigEnvelope },
    } = useEditarConfigDeEnvelopeContext();
    const { loading, lst: lstTipoRelacaoCliente } =
        useEditarConfigDeEnvelopeContext().tipoRelacaoCliente;

    async function VincularTipoRelacaoClienteDeFlagAConfiguracao(
        flag: TFlagsConfigEnvelopeDestinatario
    ) {
        await InserirConfigEnvelopeDestinatarioController({
            ID_ENVELOPE_DOCUSIGN_CONFIG: idConfigEnvelope,
            [flag]: true,
        });
    }
    async function VincularTipoRelacaoClienteAConfiguracao(
        idTipoRelacao: number
    ) {
        await InserirConfigEnvelopeDestinatarioController({
            ID_ENVELOPE_DOCUSIGN_CONFIG: idConfigEnvelope,
            ID_TIPO_RELACAO_CLIENTE: idTipoRelacao,
        });
    }

    return (
        <OrSpinner
            loading={loading}
            wrapperLoadingClasses="w-100 d-flex justify-content-center"
            loadingColor="primary"
        >
            {lstTipoRelacaoCliente?.map((tipoRelacaoCliente) => (
                <DestinatarioASerInseridoNaConfiguracao
                    descricao={tipoRelacaoCliente.DS_TIPO_RELACAO_CLIENTE}
                    key={tipoRelacaoCliente.TIPO_RELACAO_CLIENTE}
                    vincular={async () =>
                        VincularTipoRelacaoClienteAConfiguracao(
                            tipoRelacaoCliente.TIPO_RELACAO_CLIENTE
                        )
                    }
                    idVinculado={
                        lstDestinatariosConfigEnvelope.find(
                            (d) =>
                                d.ID_TIPO_RELACAO_CLIENTE ===
                                tipoRelacaoCliente.TIPO_RELACAO_CLIENTE
                        )?.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO
                    }
                />
            ))}
            {Object.entries(objTipoRelacaoClientePorFlag).map(
                ([flag, descricao]: [string, string]) => (
                    <DestinatarioASerInseridoNaConfiguracao
                        descricao={descricao}
                        key={flag}
                        vincular={async () =>
                            VincularTipoRelacaoClienteDeFlagAConfiguracao(
                                flag as TFlagsConfigEnvelopeDestinatario
                            )
                        }
                        idVinculado={
                            lstDestinatariosConfigEnvelope.find(
                                (d) =>
                                    d[flag as TFlagsConfigEnvelopeDestinatario]
                            )?.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO
                        }
                    />
                )
            )}
        </OrSpinner>
    );
}
